import { Toast, ToastOptions } from "react-hot-toast";
import { ReactNode } from "react";

export enum ToastType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
  Acrylic = "acrylic",
  Default = "default",
  Loading = "loading",
}

export interface ToastSettings extends ToastOptions {
  iconUrl?: string;
  messageTitle?: string;
  user?: {
    avatarUrl?: string;
    email?: string;
    name?: string;
    surname?: string;
  };
  actionButtonLabel?: string;
  onActionButtonClick?(): void;
}

export interface ToastProps extends ToastSettings {
  message: ReactNode;
  toastType: ToastType;
  toastSettings?: Toast;
}

export interface CustomToast {
  success: (message: ReactNode, toastProps?: ToastSettings) => string;
  error: (message: ReactNode, toastProps?: ToastSettings) => string;
  warning: (message: ReactNode, toastProps?: ToastSettings) => string;
  info: (message: ReactNode, toastProps?: ToastSettings) => string;
  loading: (message: ReactNode, toastProps?: ToastSettings) => string;
  acrylic: (message: ReactNode, toastProps?: ToastSettings) => string;
  default: (message: ReactNode, toastProps?: ToastSettings) => string;
  dismiss(toastId?: string): void;
  remove(toastId?: string): void;
}
